<template>
    <div class="pic-wrap">
        <div class="header-return" v-if="picFrom!='noReturn'">
            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            <h2>{{picName}}</h2>
        </div>
        <div>
            <el-tabs tab-position="left" @tab-click="handleClick" v-model="picTabSel">
                <template v-for="item in picTabList">
                    <el-tab-pane :label="item.name" :name="picType+item.type">
                        <div class="pic-btn-wrap">
                            <el-select v-model="proId" @change="pageSelectchange" clearable filterable placeholder="请选择页面">
                                <el-option
                                        v-for="item in pageList"
                                        :key="item.linkId"
                                        :label="item.pageTitle"
                                        :value="item.linkId">
                                </el-option>
                            </el-select>
                            <p>*可拖拽排序图片</p>
                            <el-button type="success" @click="addProduct(item.limitCount)" class="header-btn" icon="el-icon-plus"></el-button>
                            <el-button type="danger" @click="delProductAllPic()" class="header-btn">清除所有图片</el-button>
                        </div>
                        <div class="drag-container">
                            <table class="drag-container">
                                <thead>
                                <tr>
                                    <th width="60">序号</th>
                                    <th>名称</th>
                                    <th>图片</th>
                                    <th>操作</th>
                                </tr>
                                </thead>
                                <draggable v-model="picData" tag="tbody" @change="changeListSort">
                                    <tr v-for="(item,index) in picData">
                                        <td>{{index+1}}</td>
                                        <td>{{item.picName}}</td>
                                        <td>
                                            <el-image
                                                style="width: 100px; max-height: 200px"
                                                :src="item.fullRelativeUrl"
                                                :preview-src-list="[item.fullRelativeUrl]">
                                            </el-image>
                                        </td>
                                        <td>
                                            <el-button-group>
                                                <el-button type="danger" size="mini" @click="delProPic(item)">删除</el-button>
                                                <el-tooltip class="item" effect="dark" content="用户点击图片后跳转连接地址或设置图片为按钮" placement="top-start">
                                                    <el-button type="success" size="mini" @click="showLinkUrl(item)">图片设置</el-button>
                                                </el-tooltip>
                                            </el-button-group>
                                        </td>
                                    </tr>
                                </draggable>
                            </table>
                        </div>
                    </el-tab-pane>
                </template>
            </el-tabs>
        </div>
        <el-dialog
                title="图片加连接"
                :visible.sync="centerDialogVisible"
                width="50%"
                center>
            <el-form :model="picLink"  label-width="100px" class="demo-ruleForm">
                <el-form-item label="图片类型" >
                    <el-select v-model="picLink.propertyRemark" @change="picTypeSelect"  clearable filterable placeholder="图片">
                        <el-option
                                v-for="item in picTypeNameList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="图片连接" v-show="picLink.propertyRemark=='图片连接'">
                    <el-input v-model="picLink.propertyValue" placeholder="添加图片连接" ></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button-group>
                        <el-button type="danger" size="mini" @click="delPicLink()">删除</el-button>
                        <el-button type="primary" size="mini" @click="savePicLink()">确 定</el-button>
                    </el-button-group>
                </el-form-item>
            </el-form>
        </el-dialog>
        <picDialog :proId="this.proId" :picType="picTabSel"></picDialog>

    </div>
</template>

<script>
    import picDialog from '@/components/pic_dialog/pic_list'
    import draggable from 'vuedraggable'
    import { getProductPics,getPageLinkList,saveActivePropertyListApi,getActiveProperty} from '../../api/api'
    import ElButtonGroup from "../../../node_modules/element-ui/packages/button/src/button-group";
    export default{
        data(){
            return {
                picTabSel:this.$route.query.picType+'1',
                picType:this.$route.query.picType,
                picName:this.$route.query.picName||this.$route.query.activeName||'',
                picFrom:this.$route.query.picFrom,
                proId:this.$route.query.id||this.$route.query.proId||this.$route.query.activeNo,
                activeType:this.$route.query.activeType||0,
                dialogFormVisiblePicAdd:false,
                centerDialogVisible: false,
                pageList: [],//页面列表
                showLink:false,
                picData:[],
                picLink:{
                    propertyName: '',
                    propertyValue: '',
                    propertyRemark: '图片连接',
                    propertyId: '',
                    propertyKey: 'picLink',
                    status: 1,
                    bindCode:this.$route.query.bindCode
                },
                picTypeNameList:[{id:'图片连接',name:'图片连接'},{id:'支付按钮',name:'支付按钮'},{id:'分享按钮',name:'分享按钮'},{id:'兑换按钮',name:'兑换按钮'}],
                formInline: {
                    currentPage: 1,
                    pageSize: 200,
                    pageTitle: '',
                    pageLink: '',
                    linkTpye: '',
                    activeType: this.$route.query.activeType||0,
                    recordsTotal: 0,
                },
            }
        },
        computed:{
            picTabList:function () {
                return  [{
                    name:'活动图片',
                    type:'1',
                    limitCount:999
                }]
            }
        },
        components:{
            ElButtonGroup, picDialog,
            draggable
        },
        mounted(){
            if(this.activeType==22||this.activeType==19){
                this.getLinkList();
            }
        },
        methods:{
            handleClick(){
                getProductPics({proId:this.proId,picType:this.picTabSel}).then((res) => {
                    this.picData=res.data.value
                })
            },
            getLinkList(){
                this.loading = true;
                let _this=this
                getPageLinkList(this.formInline).then((res) => {
                    _this.loading = false;
                    _this.pageList = res.data.value.list;
                    _this.proId= res.data.value.list[0].linkId
                    _this.handleClick();
                })
            },
            showLinkUrl(item){
                console.log(item)
                this.centerDialogVisible = true
                this.picLink={
                    propertyName: item.picId,
                    propertyValue: '',
                    propertyRemark: '',
                    propertyId: '',
                    propertyKey: 'picLink',
                    status: 1,
                    bindCode:this.$route.query.bindCode
                }
                console.log(this.picLink)
                this.picLink.propertyName=item.picId
                getActiveProperty({propertyName: item.picId,propertyKey:'picLink'}).then((res) => {
                    if (res.data.status == 200) {
                        if(res.data.value!=''){
                            this.picLink=res.data.value
                        }
                        console.log(this.picLink);
                    }else {
                        this.$message({
                            showClose: true,
                            message: '',
                            type: 'error'
                        });
                    }
                });
            },
            pageSelectchange(selectValue){
                this.proId=selectValue;
                this.handleClick();
            },
            picTypeSelect(selectValue){
                this.showLink=selectValue=='图片连接'?true:false
                console.log(this.picLink)
            },
            addProduct(limit){
                if(limit<=this.picData.length){
                    this.$message({
                        showClose: true,
                        message: "最多上传" + limit + "个",
                        type: 'error'
                    });
                    return;
                }
                this.$store.commit('SET_PIC_DIALOG',true)
            },
            savePicLink(){
                //保存图片连接
                this.loading = true;
                console.log(this.picLink);
                saveActivePropertyListApi({itemList: encodeURIComponent(JSON.stringify(this.picLink))}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.showDialog = false;
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.handleClick()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            delPicLink(){
                //保存图片连接
                this.loading = true;
                console.log(this.picLink);
                deleteActiveProperty({propertyId:this.picLink.propertyId}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.showDialog = false;
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.handleClick()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            delProductAllPic(){
                const _this = this;
                this.$confirm('清除该商品/活动的所有图片, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    center:true,
                    type: 'warning'
                }).then(() => {
                    _this.$store.dispatch('clearProductPic',{proId: row.proId,picType:this.picType}).then((res) => {
                        if (res.status == 200) {
                            _this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            _this.handleClick()
                        } else {
                            _this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                    _this.$message({
                        showClose: true,
                        message: '取消删除',
                        type: 'error'
                    });
                })
            },
            delProPic(row){
                const _this = this;
                this.$confirm('删除图片, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    center:true,
                    type: 'warning'
                }).then(() => {
                    _this.$store.dispatch('delProImg',{picId: row.picId}).then((res) => {
                        if (res.status == 200) {
                            _this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            _this.handleClick()
                        } else {
                            _this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                    _this.$message({
                        showClose: true,
                        message: '取消删除',
                        type: 'error'
                    });
                })
            },
            returnHistory(){
                window.history.back()
            },
            changeListSort(evt){
                console.log(evt.moved)
                let moveItem = evt.moved;
                this.$store.dispatch('changePicListSort',{picId:moveItem.element.picId,sort:moveItem.newIndex+1,proId:this.proId,picType:this.picTabSel})
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .pic-wrap{
        padding: 10px;
    }
    .header-return{
        margin-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 10px;
        position: relative;
        h2{
            text-align: center;
            position: absolute;
            left: 50%;
            top:0;
            margin: 0;
        }
    }
    .pic-btn-wrap{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;
        p{
            color: #e50011;
            font-size: 20px;
            margin: 0;
        }
    }
    .header-btn{
        margin-left: 20px;
        font-size: 24px;
        font-weight: bold;
        padding: 5px 10px;
    }
    .drag-container{
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #606266;
        border-spacing: 0;
        border-collapse: collapse;
        img{
            width: 70px;
            height: 70px;
        }
        td,th{
            padding: 12px 0;
            border:1px solid #EBEEF5;

        }
        th{
            background: #eef1f6;
            color: #222222;
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/active/activePicture.vue